/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractDataService, LoggerService } from '@pf/shared-services';
import { ProjectLineItemsService } from '@control-tower/platform-wms';
import {
    EntityChangeTrackingDto,
    IChangesSearchParams,
    IPagedResult,
    PFWmsEntities,
} from '@pf/shared-common';
import { ProjectLineItemStore } from './project-line-item.store';
import {
    ProjectLineItemCreate,
    ProjectLineItemRead,
    ProjectLineItemSearchParams,
} from '../../entities/project-line-item.dto';
import { Operation } from 'fast-json-patch';

@Injectable()
export class ProjectLineItemDataService extends AbstractDataService<
    ProjectLineItemRead,
    ProjectLineItemCreate
> {
    protected EntityName = PFWmsEntities.ProjectLineItem;
    constructor(
        private service: ProjectLineItemsService,
        store: ProjectLineItemStore,
        logger: LoggerService
    ) {
        super(store, logger);
    }
    protected createObs$(
        body: ProjectLineItemCreate,
        projectId?: string
    ): Observable<ProjectLineItemRead> {
        return this.service.projectLineItemCreate({
            projectId: projectId as string,
            projectLineItemViewModelCreateBody: body,
        }) as Observable<ProjectLineItemRead>;
    }
    protected deleteObs$(
        id: string,
        projectId?: string
    ): Observable<ProjectLineItemRead> {
        return this.service.projectLineItemDelete({
            projectId: projectId as string,
            id: id,
        }) as Observable<ProjectLineItemRead>;
    }
    protected undoDeleteObs$(
        id: string,
        projectId?: string
    ): Observable<ProjectLineItemRead> {
        return this.service.projectLineItemUndoDelete({
            projectId: projectId as string,
            id,
        }) as Observable<ProjectLineItemRead>;
    }
    protected getObs$(
        id: string,
        projectId?: string
    ): Observable<ProjectLineItemRead> {
        return this.service.projectLineItemReadById({
            projectId: projectId as string,
            id,
        }) as Observable<ProjectLineItemRead>;
    }
    protected updateObs$(
        id: string,
        operations: Operation[],
        _: ProjectLineItemCreate,
        projectId?: string
    ): Observable<ProjectLineItemRead> {
        return this.service.projectLineItemUpdatePatch({
            projectId: projectId as string,
            id,
            operation: operations,
        }) as Observable<ProjectLineItemRead>;
    }
    protected searchObs$(
        searchParams: ProjectLineItemSearchParams
    ): Observable<IPagedResult<ProjectLineItemRead>> {
        return this.service.projectLineItemSearch(searchParams) as Observable<
            IPagedResult<ProjectLineItemRead>
        >;
    }

    protected searchChangesObs$(
        searchParams: IChangesSearchParams
    ): Observable<IPagedResult<EntityChangeTrackingDto<ProjectLineItemRead>>> {
        const { parentId, ...params } = searchParams;
        return this.service.projectLineItemGetChanges({
            ...params,
            projectId: parentId as string,
        }) as Observable<
            IPagedResult<EntityChangeTrackingDto<ProjectLineItemRead>>
        >;
    }
}
